/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataFromJSON, MetaDataToJSON, } from './MetaData';
import { NamedResourceTagFromJSON, NamedResourceTagToJSON, } from './NamedResourceTag';
import { OrganisationListEntryFromJSON, OrganisationListEntryToJSON, } from './OrganisationListEntry';
import { UserListEntryFromJSON, UserListEntryToJSON, } from './UserListEntry';
/**
 * Check if a given object implements the AccessGrantListEntry interface.
 */
export function instanceOfAccessGrantListEntry(value) {
    var isInstance = true;
    isInstance = isInstance && "fromOrganisation" in value;
    return isInstance;
}
export function AccessGrantListEntryFromJSON(json) {
    return AccessGrantListEntryFromJSONTyped(json, false);
}
export function AccessGrantListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'tags': !exists(json, 'tags') ? undefined : (json['tags'].map(NamedResourceTagFromJSON)),
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'fromOrganisation': OrganisationListEntryFromJSON(json['fromOrganisation']),
        'toUser': !exists(json, 'toUser') ? undefined : UserListEntryFromJSON(json['toUser']),
        'toOrganisation': !exists(json, 'toOrganisation') ? undefined : OrganisationListEntryFromJSON(json['toOrganisation'])
    };
}
export function AccessGrantListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'tags': value.tags === undefined ? undefined : (value.tags.map(NamedResourceTagToJSON)),
        'metaData': MetaDataToJSON(value.metaData),
        'id': value.id,
        'fromOrganisation': OrganisationListEntryToJSON(value.fromOrganisation),
        'toUser': UserListEntryToJSON(value.toUser),
        'toOrganisation': OrganisationListEntryToJSON(value.toOrganisation)
    };
}
